// extracted by mini-css-extract-plugin
export default {"text":"FindingOpponent2_text__UHBT4","text_vs":"FindingOpponent2_text_vs__dskYd"};